import {ITEM_TYPE_EVENT, ITEM_TYPE_PROJECT, ITEM_TYPE_TASK} from "../const/item"

export default class DependenciesManager {

    static normalizeLink(type:any, firstId:ID, secondId:ID) {
        const { START_FINISH, FINISH_START } = gd.const.gantt.linkTypes
        let res = {type,firstId,secondId}

        if(type === START_FINISH) {
            res.type        = FINISH_START
            res.firstId     = secondId
            res.secondId    = firstId
        }

        return res;
    }

    static normalizeDependency(dependency:any) {
        return dependency.type === gd.const.gantt.linkTypes.START_FINISH ? {
            type        : gd.const.gantt.linkTypes.FINISH_START,
            task1Id     : dependency.task2Id,
            task2Id     : dependency.task1Id,
            project1Id  : dependency.project2Id,
            project2Id  : dependency.project1Id,
            event1Id    : dependency.event2Id,
            event2Id    : dependency.event1Id
        } : dependency
    }

    static convertDependencyToFirstSecond(dependency:any) {
        const dep:any   = DependenciesManager.normalizeDependency(dependency)
        const res:any   = {type: dep.type}

        const regExp = /(\w+)([1,2])Id/g

        _.mapKeys(dep, (value, key)=>{
            if (value) {
                let matchArr = key ? [...key.matchAll(regExp)] : []
                const match = matchArr[0]

                if (match) {
                    let prefix = ''
                    switch (match[1]) {
                        case 'task'     : prefix = 't-'; break
                        case 'project'  : prefix = 'p-'; break
                        case 'event'    : prefix = 'e-'; break
                    }

                    switch (match[2]) {
                        case '1': res.firstId   = prefix + value; break
                        case '2': res.secondId  = prefix + value; break
                    }
                }
            }
        })

        return res
    }

    static convertFirstSecondToDependency(type:any, firstId:ID, secondId:ID) {
        const res:any = {type}

        const getPrefixId = (value:string) => {
            const arr = value.split('-')

            let prefix = ''
            switch (arr[0]) {
                case 't': prefix = 'task'; break
                case 'p': prefix = 'project'; break
                case 'e': prefix = 'event'; break
            }
            return {prefix, id:arr[1]}
        }

        {
            const {prefix, id} = getPrefixId(firstId);
            res.task1Id     = prefix === 'task' ?       id : null
            res.project1Id  = prefix === 'project' ?    id : null
            res.event1Id    = prefix === 'event' ?      id : null
        }

        {
            const {prefix, id} = getPrefixId(secondId);
            res.task2Id     = prefix === 'task' ?       id : null
            res.project2Id  = prefix === 'project' ?    id : null
            res.event2Id    = prefix === 'event' ?      id : null
        }

        return res;
    }

    static convertToDependencyFromItems(type:any, firstItem:any, secondItem:any) {
        return {
            "type"      : type,

            "task1Id"   : firstItem.type  === ITEM_TYPE_TASK  ?     firstItem.item.id  : null,
            "project1Id": firstItem.type  === ITEM_TYPE_PROJECT ?   firstItem.item.id  : null,
            "event1Id"  : firstItem.type  === ITEM_TYPE_EVENT ?     firstItem.item.id  : null,

            "task2Id"   : secondItem.type === ITEM_TYPE_TASK  ?     secondItem.item.id : null,
            "project2Id": secondItem.type === ITEM_TYPE_PROJECT ?   secondItem.item.id : null,
            "event2Id"  : secondItem.type === ITEM_TYPE_EVENT ?     secondItem.item.id : null,
        }
    }

    static findExistingDependency(dependencies:any[], dependency:any) {
        const createSearchItem = (data:any) => {
            let res = []
            if (data.task1Id)       res.push('t-'+data.task1Id)
            if (data.task2Id)       res.push('t-'+data.task2Id)
            if (data.project1Id)    res.push('p-'+data.project1Id)
            if (data.project2Id)    res.push('p-'+data.project2Id)
            if (data.event1Id)      res.push('e-'+data.event1Id)
            if (data.event2Id)      res.push('e-'+data.event2Id)
            return res;
        }

        const newDep = createSearchItem(dependency)

        return _.find(dependencies, d=>_.intersection(newDep,createSearchItem(d)).length === 2)
    }

    static findDependencyItem(items:any[], listItemType:string, listItemId:ID) {
        let prefix = ''
        switch (listItemType) {
            case 'task'     : prefix = 't'; break
            case 'project'  : prefix = 'p'; break
            case 'event'    : prefix = 'e'; break
        }
        const item = _.find(items, t=> '{0}-{1}'.f(prefix, t.id) === listItemId)
        if (item) item.dependencyItemType = listItemType
        return item
    }

    // static updateSuccessorPredecessor(data:any, dependency:any) {
    //     const {firstId:sourceID, secondId:targetID} = DependenciesManager.convertDependencyToFirstSecond(dependency);
    //
    //     let source, target
    //     if (!source && data.tasks)      source = DependenciesManager.findDependencyItem(data.tasks, 'task', sourceID)
    //     if (!source && data.projects)   source = DependenciesManager.findDependencyItem(data.projects, 'project', sourceID)
    //     if (!source && data.events)     source = DependenciesManager.findDependencyItem(data.events, 'event', sourceID)
    //
    //     if (!target && data.tasks)      target = DependenciesManager.findDependencyItem(data.tasks, 'task', targetID)
    //     if (!target && data.projects)   target = DependenciesManager.findDependencyItem(data.projects, 'project', targetID)
    //     if (!target && data.events)     target = DependenciesManager.findDependencyItem(data.events, 'event', targetID)
    //
    //     if (!!source && !!target){
    //         if (source.successors)      { source.successors.push(target) }
    //         else                        { source.successors = [target] }
    //
    //         if (target.predecessors)    { target.predecessors.push(source) }
    //         else                        { target.predecessors = [source] }
    //     }
    // }
}